<template>
  <div>
    <template v-if="isConfiguring">
      <BeatLoaderPrimary :style="style.loader" />
    </template>
    <template v-else>
      <router-view />
    </template>
    <NotificationPrimary />
    <NotificationWarning />
  </div>
</template>

<script>
  import ApiCurrentUser from '@js/api/current-user'
  import ApiGlobalVariable from '@js/api/global-variable'
  import ApiTokenRevoke from '@js/api/token-revoke'
  import BeatLoaderPrimary from '@modules/v2/loader/beat-loader-primary'
  import NotificationPrimary from '@modules/notification/notification-primary'
  import NotificationWarning from '@modules/notification/notification-warning'
  import { bootstrapAuth } from '@js/auth-utils'
  import { mapGetters, mapState } from 'vuex'
  import { initStore } from '@store/utils'

  export default {
    name: 'RootUserView',
    components: {
      BeatLoaderPrimary,
      NotificationPrimary,
      NotificationWarning,
    },
    data: function () {
      return {
        isConfiguring: true,
        serviceParamMutations: {
          experiencePeriodCategories: 'serviceParams/setExperiencePeriodCategories',
          languageCodes: 'serviceParams/setLanguageCodes',
          skillStatusTypes: 'serviceParams/setSkillStatusTypes',
          timezoneCodes: 'serviceParams/setTimezoneCodes',
        },
        style: {
          loader: {
            height: '100vh',
            width: '100%',
          },
        },
      };
    },
    created: async function () {
      await bootstrapAuth();

      if (!this.authorized) {
        await this.onUnauthorized();
        return;
      }

      await this.initialize();
    },
    computed: {
      ...mapGetters('auth', ['authorized']),
      ...mapState({
        refresh: state => state.auth.refresh,
      }),
    },
    methods: {
      fetchCurrentUser: async function () {
        try {
          const api = await new ApiCurrentUser();
          const res = await api.get();
          await this.$store.commit('user/setUser', res.data);
        } catch (error) {
          this.$store.commit(
            'notification/setWarning',
            'User not found or authorized',
          );
          throw error;
        }
      },
      fetchGlobalVariable: async function () {
        try {
          const api = await new ApiGlobalVariable();
          const res = await api.get();
          await this.$store.commit('globalVariables/set', res.data);

          await Object.entries(this.serviceParamMutations).forEach(
            async ([paramName, mutation]) => {
              await this.$store.commit(mutation, res.data[paramName]);
            }
          );
        } catch (error) {
          this.$store.commit(
            'notification/setWarning',
            'Failed to fetch system parameters.',
          );
          throw error;
        }
      },
      initialize: async function () {
        try {
          this.isConfiguring = await true;
          await this.fetchCurrentUser();
          await this.fetchGlobalVariable();
        } catch (error) {
          await console.error(error);
          await initStore();
          await this.$router.push({ name: 'login' });
        } finally {
          this.isConfiguring = false;
        }
      },
      onUnauthorized: async function () {
        try {
          this.isConfiguring = await true;
          await initStore();
          await this.$router.push({ name: 'login' });
        } catch (error) {
          console.error(error);
        } finally {
          this.isConfiguring = false;
        }
      },
      revokeToken: async function (refresh) {
        const payload = {
          refresh: refresh,
        };
        const api = await new ApiTokenRevoke();
        const res = await api.post(payload);
      },
    },
    watch: {
      authorized: async function (newVal, oldVal) {
        if (newVal) {
          await this.initialize();
          await this.$router.push({ name: 'tenants' });
        } else {
          await this.onUnauthorized();
        }
      },
      refresh: async function (newVal, oldVal) {
        if (oldVal) {
          await this.revokeToken(oldVal);
        }
      }
    },
  };
</script>
